import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';

export const licenceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLicenses: builder.query({
      query: (args = {}) => ({
        url: '/api/licenses',
        params: buildListQueryParams(args),
      }),
      providesTags: ['Licences'],
    }),
  }),
});

export const { useGetLicensesQuery } = licenceApi;
